import ApptUser from "./ApptUser.svg";
import ArrowLeftIcon from "./ArrowLeft.svg";
import BellSimpleIcon from "./BellSimpleIcon.svg";
import CalendarIcon from "./CanlendarIcon.svg";
import CaretUpIcon from "./CaretUpIcon.svg";
import ChatIcon from "./ChatIcon.svg";
import ClearIcon from "./ClearIcon.svg";
import CopyIcon from "./CopyIcon.svg";
import DesktopLogo from "./DesktopLogo.svg";
import DollarIcon from "./DollarIcon.svg";
import DuplicateIcon from "./Duplicate.svg";
import Echo2Logo from "./Echo2Logo.svg";
import EchoLogo from "./EchoLogo.svg";
import EdenLogo from "./EdenLogo.svg";
import EnvelopeIcon from "./EnvolopeIcon.svg";
import HolidayEventIcon from "./event.svg";
import FilterIcon from "./FilterIcon.svg";
import FrameIcon from "./Frame.svg";
import HomeIcon from "./HomeIcon.svg";
import InventoryIcon from "./InventoryIcon.svg";
import InvestigationIcon from "./InvestigationIcon.svg";
import InvoiceIcon from "./InvoiceIcon.svg";
import ModalSuccessIcon from "./ModalSuccessIcon.svg";
import ModalWarningIcon from "./ModalWarningIcon.svg";
import NotePencilIcon from "./NotePencilIcon.svg";
import PatientIcon from "./PatientIcon.svg";
import PenIcon from "./PenIcon.svg";
import PharmacyIcon from "./PharmacyIcon.svg";
import PlusBlackIcon from "./PlusBlackIcon.svg";
import PlusIcon from "./PlusIcon.svg";
import PrintIcon from "./PrintIcon.svg";
import QueueIcon from "./QueueIcon.svg";
import RecordPaymentIcon from "./RecordPaymentIcon.svg";
import ReportIcon from "./ReportIcon.svg";
import SearchIcon from "./SearchIcon.svg";
import SettingsIcon from "./SettingIcon.svg";
import SpeakerHighIcon from "./SpeakerHighIcon.svg";
import SpeakerNoneIcon from "./SpeakerNoneIcon.svg";
import SuccessIcon from "./SuccesIcon.svg";
import ThreeDotIcon from "./ThreeDotIcon.svg";
import ClockIcon from "./Time.svg";
import TrashIcon from "./TrashIcon.svg";
import UserIcon from "./UserIcon.svg";
import VisitTypeIcon from "./VisitTypeIcon.svg";
import WarningWhiteIcon from "./Warning.svg";
import WarningIcon from "./WarningIcon.svg";
import WarningIconYellow from "./WarningIconYellow.svg";
import WarningYellowIcon from "./WarningYellowIcon.svg";
import XCircleIcon from "./XCircle.svg";
import XCircleOutlinedIcon from "./XCircleOutlined.svg";

const SVG_ICON = {
  FrameIcon,
  EchoLogo,
  HomeIcon,
  ArrowLeftIcon,
  CalendarIcon,
  ChatIcon,
  DollarIcon,
  EnvelopeIcon,
  InventoryIcon,
  InvestigationIcon,
  InvoiceIcon,
  PatientIcon,
  PharmacyIcon,
  QueueIcon,
  ReportIcon,
  SettingsIcon,
  FilterIcon,
  SearchIcon,
  XCircleIcon,
  ClearIcon,
  PlusIcon,
  TrashIcon,
  WarningIcon,
  SuccessIcon,
  WarningYellowIcon,
  ThreeDotIcon,
  PlusBlackIcon,
  BellSimpleIcon,
  UserIcon,
  PenIcon,
  PrintIcon,
  CaretUpIcon,
  ModalSuccessIcon,
  ModalWarningIcon,
  EdenLogo,
  Echo2Logo,
  CopyIcon,
  RecordPaymentIcon,
  SpeakerHighIcon,
  SpeakerNoneIcon,
  XCircleOutlinedIcon,
  NotePencilIcon,
  DesktopLogo,
  HolidayEventIcon,
  WarningWhiteIcon,
  VisitTypeIcon,
  ApptUser,
  ClockIcon,
  DuplicateIcon,
  WarningIconYellow,
};

export default SVG_ICON;
